import {useParams} from 'react-router'

import {AreaNavigation, AreaRouteSegments} from '../types'

import {useReplaceAreaIdParam} from './useReplaceAreaIdParam'

/** Navigation for hosts that encode the area in the URL as `<area>/:areaId` (legacy hroc routes). */
export const useRouteSegmentsAreaNavigation = (
  routeSegments: AreaRouteSegments
): AreaNavigation => {
  const {areaId} = useParams<{areaId: string}>()
  const replaceAreaId = useReplaceAreaIdParam(routeSegments.area)

  return {
    areaId,
    getPlantLink: (plantId) => `${routeSegments.plant}/${plantId}`,
    getAreaLink: (id) => `${routeSegments.area}/${id}`,
    onAreaChange: replaceAreaId,
    unsupportedAreaRedirect: routeSegments.plant
  }
}
